export default [
  {
    path: '/accueil/spot-tv',
    name: 'tvSpotList',
    component: () => import('@/views/Home/TvSpot/List.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/accueil/spot-tv/creation',
    name: 'tvSpotCreate',
    component: () => import('@/views/Home/TvSpot/Create.vue'),
    meta: {
      layout: 'content'
    }
  },
  {
    path: '/accueil/spot-tv/:tvSpotId',
    name: 'tvSpotDetails',
    component: () => import('@/views/Home/TvSpot/Details.vue'),
    meta: {
      layout: 'content'
    }
  }
]
